import { useEffect, useCallback } from 'react'
import { useCookies } from 'react-cookie'

const VersionChecker = () => {
	const [cookies, setCookie] = useCookies<'build_time', { build_time?: string }>()

	const checkBuildInfo = useCallback(() => {
		fetch(`/build-info.json`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((response) => {
				return response.json()
			})
			.then((data: { time: string }) => {
				const prevBuildTime = cookies.build_time
				const buildTime = data.time

				if (prevBuildTime !== buildTime) {
					setCookie('build_time', buildTime, { path: '/', maxAge: 60 * 60 * 24 * 31 * 12 })
					window.location.reload()
				} else {
					setCookie('build_time', buildTime, { path: '/', maxAge: 60 * 60 * 24 * 31 * 12 })
				}
			})
			.catch(() => {
				// console.error('build-info load error')
			})
	}, [cookies.build_time, setCookie])

	useEffect(() => {
		checkBuildInfo()
	}, [checkBuildInfo])

	return null
}

export default VersionChecker
